/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import Lottie from 'lottie-react';

import { css, jsx } from '@atlaskit/css';
import { useIsReducedMotion } from '@atlaskit/motion/use-is-reduced-motion';
import { token } from '@atlaskit/tokens';

import remixAnimationCardPurple from './RemixPlaceholder/assets/remix-animation-card-purple.png';
import remixAnimation from './RemixPlaceholder/assets/remix-animation.json';

const REMIX_ANIMATION_IMAGE_ASSET_ID = 'card_purple_1_1';

const remixAnimationData = {
	...remixAnimation,
	assets: remixAnimation.assets.map((asset) =>
		asset.id === REMIX_ANIMATION_IMAGE_ASSET_ID
			? { ...asset, p: remixAnimationCardPurple, u: '' }
			: asset,
	),
};

const placeholderStyles = css({
	width: '100%',
	maxWidth: '760px',
	aspectRatio: '16 / 9',
	borderRadius: token('radius.large'),
	marginTop: token('space.150'),
	marginRight: 'auto',
	marginBottom: token('space.150'),
	marginLeft: 'auto',
	overflow: 'hidden',
	pointerEvents: 'none',
});

const rendererSettings = { preserveAspectRatio: 'xMidYMid meet' };

/** Marks where an accepted SUGGESTED_REMIX result will land while its card is active. */
export function RemixPlaceholder(): JSX.Element {
	const isReducedMotion = useIsReducedMotion();

	return (
		<Lottie
			key={isReducedMotion ? 'reduced-motion' : 'animated'}
			animationData={remixAnimationData}
			autoplay={!isReducedMotion}
			loop={false}
			rendererSettings={rendererSettings}
			css={placeholderStyles}
			aria-hidden="true"
			data-testid="ai-suggestions-remix-placeholder"
		/>
	);
}
